import React, { createContext, useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { BaseURL, getData } from "../FatchApi/FatchApi";

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const navigate = useNavigate();
  const [authenticated, setAuthenticated] = useState(false);

  const checkAuth = async () => {
    try {
      const res = await getData('api/users/profile');

      // Only admins may use the dashboard
      return Boolean(res && (res.success || res.status === "success") && res.user?.isAdmin);
    } catch {
      return false;
    }
  };

  const logout = async () => {
    // Clear all cookies client-side (broad coverage including subdomains)
    document.cookie.split(";").forEach((cookie) => {
      const eqPos = cookie.indexOf("=");
      const name = eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie;
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.sapphirenuts.in`;
    });

    try {
      await fetch(`${BaseURL}/api/auth/logout`, {
        method: 'POST',
        credentials: 'include',
      });
    } catch (e) {
      console.log('Logout API call failed:', e);
    }
    localStorage.clear();
    setAuthenticated(false);
    navigate('/', { replace: true });
  };

  // Initial auth check
  useEffect(() => {
    checkAuth().then(setAuthenticated);
  }, []);

  // Event listener + periodic check
  useEffect(() => {
    const handleAuthExpired = () => logout();

    const interval = setInterval(() => {
      checkAuth().then((valid) => {
        if (!valid) logout();
      });
    }, 300000); // 5 minutes

    window.addEventListener('authExpired', handleAuthExpired);
    return () => {
      clearInterval(interval);
      window.removeEventListener('authExpired', handleAuthExpired);
    };
  }, [navigate]);

  return (
    <AuthContext.Provider value={{ authenticated, setAuthenticated, logout, checkAuth }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;

